import { brandingToTokens, type TenantBranding } from '@auctisync/color';
import { useMemo } from 'react';

/**
 * Resolve a tenant's stored branding blob into the AA-guaranteed --brand-*
 * inline CSS variables for the current mode (spec §7/§8; branding scope locked
 * 2026-07-14: logo + primary + accent). Spread the result into the style of a
 * `data-theme="bidder"` container to theme the bidder surface in the tenant's
 * brand. Returns {} when the tenant set no primary color (falls back to the
 * AuctiSync default tokens).
 *
 * The mapping (including the accessible hover/fg/link derivations) lives in
 * @auctisync/color's brandingToTokens — the single source of truth every
 * surface shares, so a tenant's primary_color always means --brand-primary.
 */
export function useTenantBrandStyle(
  branding: Record<string, unknown> | null | undefined,
  mode: 'light' | 'dark',
): React.CSSProperties {
  return useMemo(
    // brandingToTokens returns a Record of CSS custom properties; React accepts
    // custom props on style at runtime, but the type doesn't include arbitrary
    // '--x' keys, so cast.
    () => brandingToTokens((branding ?? {}) as TenantBranding, mode) as React.CSSProperties,
    [branding, mode],
  );
}
